import { render, staticRenderFns } from "./CustomerRequestProductStep.vue?vue&type=template&id=6f07a6f8&scoped=true&"
import script from "./CustomerRequestProductStep.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestProductStep.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRequestProductStep.vue?vue&type=style&index=0&id=6f07a6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07a6f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f07a6f8')) {
      api.createRecord('6f07a6f8', component.options)
    } else {
      api.reload('6f07a6f8', component.options)
    }
    module.hot.accept("./CustomerRequestProductStep.vue?vue&type=template&id=6f07a6f8&scoped=true&", function () {
      api.rerender('6f07a6f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/CustomerRequest/CustomerRequestComponents/CustomerRequestProductStep.vue"
export default component.exports